import React, { PureComponent } from "react";
import { Treebeard } from "react-treebeard";
import { FormGroup, Label, Input, Button } from "reactstrap";
import { cloneDeep, find, isObject } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Container from "./TreeViewContainer";
import "./TreeView.css";

const changeSelection = (node, newState) => {
  node.children.forEach(item => {
    if (item.children) return changeSelection(item, newState);
    item.checked = newState;
    return true;
  });
};

const decorators = {
  Toggle: ({ style, node }) => {
    return (
      <div style={style.base}>
        <div style={style.wrapper} className={node.hasSelection ? "nodeHasSelection" : ""}>
          {node.toggled ? (
            <FontAwesomeIcon icon={["fas", "chevron-down"]} size="lg" />
          ) : (
            <FontAwesomeIcon icon={["fas", "chevron-right"]} size="lg" />
          )}
        </div>
      </div>
    );
  },
  Header: ({ node, style }) => (
    <div style={style.base}>
      <div style={style.title}>
        {!node.children && (
          <FormGroup check>
            <Label check>
              <Input type="checkbox" readOnly checked={node.checked} /> {node.name}
            </Label>
          </FormGroup>
        )}
        {node.children && (
          <div>
            {" "}
            <Label>{node.name}</Label>{" "}
            <Button color="link" onClick={() => changeSelection(node, true)}>
              All
            </Button>
            <Button color="link" onClick={() => changeSelection(node, false)}>
              None
            </Button>{" "}
          </div>
        )}
      </div>
    </div>
  ),
  Container
};

export default class TreeView extends PureComponent {
  state = { data: {} };

  onToggle = (node, toggled) => {
    const { cursor, data } = this.state;
    const { onChange = () => {} } = this.props;
    if (cursor) {
      this.setState(() => ({ cursor }));
    }

    if (node.children) {
      node.toggled = toggled;
    } else {
      node.checked = !node.checked;
    }

    const selectedAccess = this.listSelected(data);
    onChange(selectedAccess);

    this.setState(() => ({ cursor: node, data: cloneDeep(data) }));
  };

  listSelected = (hay, selected = [], parent = {}) => {
    if (hay.children)
      hay.children.forEach(child => {
        if (this.listSelected(child, selected, hay) === true) {
          const matchingBrand = find(selected, { brand: parent.value });
          if (!matchingBrand)
            selected.push({
              brand: parent.value,
              brandDisplay: parent.name,
              markets: [
                {
                  market: hay.value,
                  marketDisplay: hay.name,
                  languages: [{ language: child.value, languageDisplay: child.name }]
                }
              ]
            });
          else {
            const matchingMarket = find(matchingBrand.markets, { market: hay.value });
            if (!matchingMarket)
              matchingBrand.markets.push({
                market: hay.value,
                marketDisplay: hay.name,
                languages: [{ language: child.value, languageDisplay: child.name }]
              });
            else matchingMarket.languages.push({ language: child.value, languageDisplay: child.name });
          }
        }
      });

    if (hay.checked) {
      return true;
    }

    return selected;
  };

  selectItems = (treeDataParam, selectedValues) => {
    const treeData = treeDataParam;

    selectedValues.forEach(brand => {
      brand.markets.forEach(market => {
        market.languages.forEach(language => {
          const matchingBrand = find(treeData.children, { value: brand.brand });
          if (matchingBrand && matchingBrand.children) {
            const matchingMarket = find(matchingBrand.children, { value: market.market });

            if (matchingMarket && matchingMarket.children) {
              const value = isObject(language) ? language.language : language;
              const matchingLanguage = find(matchingMarket.children, {
                value
              });

              if (matchingLanguage) {
                matchingMarket.hasSelection = true;
                matchingBrand.hasSelection = true;
                matchingLanguage.hasSelection = true;
                matchingLanguage.checked = true;
              }
              // else console.warn(`Can't find language ${brand.brand} - ${market.market} - ${value}`, matchingMarket);
            }
          }
        });
      });
    });
    return treeData;
  };

  clearSelection = treeData => {
    treeData.children.forEach(brand => {
      brand.hasSelection = false;
      brand.children.forEach(market => {
        market.hasSelection = false;
        market.children.forEach(language => {
          language.hasSelection = false;
          language.checked = false;
        });
      });
    });
    return treeData;
  };

  componentWillReceiveProps = newProps => {
    this.setState({ data: {} }, () => {
      const { treeData = {}, selectedValues = [] } = newProps;
      const cleanTree = this.clearSelection(treeData);
      const modifiedData = this.selectItems(cleanTree, selectedValues);
      this.setState({ data: modifiedData });
    });
  };

  render() {
    const { data = {} } = this.state;
    return (
      <div>
        <Treebeard data={data} onToggle={this.onToggle} decorators={decorators} />
      </div>
    );
  }
}
